// Constants
import { Endpoints } from "~constants/endpoints"

// Utils
import { Api } from "~utils/api"

// Shapes
import { CouponsBatchPayload } from "~shapes/coupon"

const CouponService = {
  postCouponsBatch: async (coupons: CouponsBatchPayload) => {
    const url = `${Endpoints.COUPONS.URL}/batch`
    const response = await Api.post(url, coupons)
    return response.data
  },
  postCouponsByCSV: async (file: File, redemptionType: string) => {
    const formData = new FormData()
    formData.append("file", file)
    formData.append("redemptionType", redemptionType)

    const url = `${Endpoints.COUPONS.URL}/upload`
    const response = await Api.post(url, formData)
    return response.data
  },
}

export default CouponService
